import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  countDownContainer: theme => ({
    marginLeft: 5,
    flexDirection: 'row',
    alignItems: 'center',
    opacity: 0.5,
  }),
  separatorStyle: theme => ({
    color: theme.colors.countDown?.seperator,
    fontFamily: Fonts.type.VFFont,
    fontWeight: 'normal',
  }),
  digitStyle: theme => ({
    width: 'auto',
    backgroundColor: 'transparent',
  }),
  digitTxtStyle: theme => ({
    color: theme.colors.countDown?.digit,
    fontFamily: Fonts.type.VFFont,
    fontWeight: 'normal',
    fontSize: 16.6,
    lineHeight: 22.9,
  }),
  bracket: theme => ({
    color: theme.colors.countDown?.bracket,
  }),
});
